import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkIsValueEmptyPipe'
})
export class CheckIsValueEmptyPipePipe implements PipeTransform {

  transform(value: string | number | null | undefined): boolean {
    if (typeof value === 'number') {
      return value === null || value === undefined;
    }
    return value === null || value === undefined || value.trim() === '';
  }

}
